import apiService from './api';

// Standalone client for the Candidate Portal. Deliberately does NOT reuse the
// shared apiService's auth handling - that reads/writes the employee 'token'/
// 'ct_token' keys and redirects to /login on 401, which would clobber an
// employee session or bounce a candidate to the wrong login page.
const TOKEN_KEY = 'cp_token';

const getToken = () => localStorage.getItem(TOKEN_KEY);
const setToken = (token) => localStorage.setItem(TOKEN_KEY, token);
const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const request = async (endpoint, options = {}) => {
  const token = getToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${apiService.baseURL}${endpoint}`, { ...options, headers });
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'An error occurred');
  }
  return data;
};

export const candidatePortalAPI = {
  login: async (username, password) => {
    const res = await request('/candidate-portal/login', {
      method: 'POST',
      body: JSON.stringify({ username, password })
    });
    if (res.data?.token) setToken(res.data.token);
    return res;
  },
  logout: () => clearToken(),
  isLoggedIn: () => !!getToken(),
  me: () => request('/candidate-portal/me'),
  submitDecision: (decision, reason) => request('/candidate-portal/decision', {
    method: 'POST',
    body: JSON.stringify({ decision, reason })
  })
};

export default candidatePortalAPI;
